<dx-popup
    [(visible)]="visible"
    [showTitle]="true"
    title="ตั้งค่า View ของคอลัมน์"
    [dragEnabled]="true"
    [hideOnOutsideClick]="!saving"
    [width]="980"
    maxWidth="96vw"
    height="85vh"
>
    <div class="popup-body">
        <div class="hint">
            ติ๊กว่าคอลัมน์ไหนจะแสดงใน View ไหน ใช้ร่วมกันทุกคน แต่ละเครื่องเลือก View
            ของตัวเองได้ที่ toolbar
        </div>
        <dx-scroll-view class="matrix-scroll" direction="both">
            <table class="matrix">
                <thead>
                    <tr>
                        <th class="column-name">คอลัมน์</th>
                        @for (view of draft.views; track view.id) {
                        <th class="view-head">
                            <div class="view-head-row">
                                <dx-text-box
                                    [(value)]="view.name"
                                    valueChangeEvent="input"
                                    [isValid]="view.name.trim() !== ''"
                                    [width]="130"
                                ></dx-text-box>
                                <dx-button
                                    icon="trash"
                                    stylingMode="text"
                                    hint="ลบ View นี้"
                                    [disabled]="draft.views.length === 1"
                                    (onClick)="removeView(view)"
                                ></dx-button>
                            </div>
                        </th>
                        }
                        <th>
                            <dx-button
                                icon="add"
                                text="เพิ่ม View"
                                stylingMode="outlined"
                                (onClick)="addView()"
                            ></dx-button>
                        </th>
                    </tr>
                    <tr>
                        <th
                            class="column-name"
                            title="เปิดโหมด Ordering แล้วจะสลับมา View นี้เอง และกลับ View เดิมตอนปิด"
                        >
                            เปิดเมื่อเข้าโหมด Ordering
                        </th>
                        @for (view of draft.views; track view.id) {
                        <th class="cell">
                            <dx-check-box
                                [value]="draft.orderingViewId === view.id"
                                (onValueChanged)="
                                    onOrderingViewToggled(view, $event.value)
                                "
                            ></dx-check-box>
                        </th>
                        }
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for (column of columns; track column.field) {
                    <tr>
                        <td class="column-name">
                            {{ column.caption }}
                            @if (isForced(column.field)) {
                            <span
                                class="forced"
                                title="โหมด Ordering แสดงคอลัมน์นี้เสมอ ไม่ว่าจะติ๊กหรือไม่"
                                >ขึ้นเสมอในโหมด Ordering</span
                            >
                            }
                        </td>
                        @for (view of draft.views; track view.id) {
                        <td class="cell">
                            <dx-check-box
                                [value]="isChecked(view, column.field)"
                                (onValueChanged)="
                                    onColumnToggled(
                                        view,
                                        column.field,
                                        $event.value
                                    )
                                "
                            ></dx-check-box>
                        </td>
                        }
                        <td></td>
                    </tr>
                    }
                </tbody>
            </table>
        </dx-scroll-view>
        <div class="actions">
            <dx-button
                stylingMode="outlined"
                text="ยกเลิก"
                [disabled]="saving"
                (onClick)="close()"
            ></dx-button>
            <dx-button
                stylingMode="contained"
                type="default"
                text="บันทึก"
                [disabled]="!canSave"
                (onClick)="confirm()"
            ></dx-button>
        </div>
    </div>
</dx-popup>
